import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchRelatedBlogs } from "../../features/relatedBlogs/relatedBlogsSlice";
import RelatedPost from "./RelatedPost";

export default function RelatedPosts() {
  const relatedBlogs = useSelector((state) => state.relatedBlogs.relatedBlogs);
  const blog = useSelector((state) => state.blog.blog);
  const { tags, id } = blog;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchRelatedBlogs({ tags, id }));
  }, [dispatch, id, tags]);
  return (
    <aside>
      <h4 className="mb-4 text-xl font-medium" id="lws-relatedPosts">
        Related Posts
      </h4>
      <div className="space-y-4 related-post-container">
        {relatedBlogs.map((relatedBlog) => {
          return <RelatedPost key={relatedBlog.id} relatedBlog={relatedBlog} />;
        })}
      </div>
    </aside>
  );
}
